module.exports = __webpack_public_path__ + "static/courses-top-a558155796cef0748693edd81aabc3ee.png";